/* ============================================================================
   BGR — Why They'll Love It (v2)
   Minimal JS: smooth-scroll jump link, copy-to-clipboard message ideas,
   opt-in scroll fade-in. All three use event delegation on document so they
   keep working after Shopify's theme editor re-renders the section, and the
   click handlers only get registered once even if this script runs twice.
   ============================================================================ */
(function () {
  'use strict';

  if (window.__bgrWtliInit) return;
  window.__bgrWtliInit = true;

  // If the merchant's configured jump-link ID doesn't exist on the page
  // (personalization apps don't always expose a settable ID), fall back to
  // scrolling to the product form / buy-buttons area — present on every
  // Horizon product page by default — so the button always does something
  // useful instead of silently failing.
  var FALLBACK_TARGET_SELECTORS = [
    'form[action*="/cart/add"]',
    '.product-form',
    '[id^="MainProduct-"]',
    '.product__info-wrapper',
    'product-info',
    'main-product'
  ];

  function findFallbackTarget() {
    for (var i = 0; i < FALLBACK_TARGET_SELECTORS.length; i++) {
      var el = document.querySelector(FALLBACK_TARGET_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function smoothScrollTo(targetId) {
    var target = null;
    if (targetId && targetId.charAt(0) === '#') {
      target = document.querySelector(targetId);
    }
    if (!target) {
      target = findFallbackTarget();
    }
    if (!target) return false;

    target.scrollIntoView({ behavior: 'smooth', block: 'end' });
    if (typeof target.focus === 'function') {
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
    return true;
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // Fallback for older browsers / non-secure contexts
    return new Promise(function (resolve, reject) {
      try {
        var el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style.position = 'fixed';
        el.style.opacity = '0';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var jumpLink = event.target.closest('[data-bgr-wtli-jump]');
    if (jumpLink) {
      var href = jumpLink.getAttribute('href');
      if (smoothScrollTo(href)) {
        event.preventDefault();
      }
      return;
    }

    var copyBtn = event.target.closest('[data-bgr-wtli-copy]');
    if (copyBtn) {
      var text = copyBtn.getAttribute('data-bgr-wtli-copy');
      var originalLabel = copyBtn.textContent;
      copyText(text)
        .then(function () {
          copyBtn.textContent = 'Copied!';
          copyBtn.setAttribute('data-copied', 'true');
        })
        .catch(function () {
          copyBtn.textContent = "Couldn't copy";
        })
        .finally(function () {
          setTimeout(function () {
            copyBtn.textContent = originalLabel;
            copyBtn.removeAttribute('data-copied');
          }, 1600);
        });
    }
  });

  function initAnimations(root) {
    var scope = root || document;
    var animatedSections = scope.querySelectorAll('.bgr-wtli--animate:not([data-bgr-wtli-observed])');
    if (!animatedSections.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bgr-wtli--in-view');
            entry.target.classList.remove('bgr-wtli--pre-animate');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    animatedSections.forEach(function (section) {
      section.setAttribute('data-bgr-wtli-observed', 'true');
      section.classList.add('bgr-wtli--pre-animate');
      observer.observe(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnimations(document);
  });

  // Re-init when the theme editor swaps this section back in
  document.addEventListener('shopify:section:load', function (event) {
    initAnimations(event.target);
  });
})();